/* eslint-disable prettier/prettier */
export const eyebrow = [
  'font-bold text-[#3D43FC]',
  'text-[0.938rem] leading-[1.25rem]',
  'md:text-[1.251rem] md:leading-[150%] md:tracking-[-0.019rem]'
].join(' ');

export const title = [
  'font-bold whitespace-pre-line',
  'text-[1.75rem] leading-[2.25rem]',
  'md:text-[3rem] md:leading-[3.879rem] md:tracking-[-0.063rem]'
].join(' ');

export const subtitle = [
  'whitespace-pre-line text-[#6B7280]', 
  'text-[0.938rem] leading-[1.25rem]',
  'md:text-[1.375rem] md:leading-[2rem] md:font-medium md:tracking-[-0.01875rem]'
].join(' ');
